import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //发布时添加,测试时删除  base
  base: '/dist/',
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/components/index')
    }, {
      path: '/device',
      name: 'device',
      component: () => import('@/components/star/star'),
      children: [{
          path: 'o12',
          name: 'o12',
          component: () => import('@/components/device/o12')
        },
        {
          path: 'o21',
          name: 'o21',
          component: () => import('@/components/device/o21')
        },
        {
          path: 'o22',
          name: 'o22',
          component: () => import('@/components/device/o22')
        },
        {
          path: 'r700',
          name: 'r700',
          component: () => import('@/components/device/r700')
        },
        {
          path: 'r800',
          name: 'r800',
          component: () => import('@/components/device/r800')
        },
        {
          path: 'f60',
          name: 'f60',
          component: () => import('@/components/device/f60')
        },
        {
          path: 'mm750',
          name: 'mm750',
          component: () => import('@/components/device/mm750')
        },
        {
          path: 'h18',
          name: 'h18',
          component: () => import('@/components/device/h18')
        },
        {
          path: 'd30',
          name: 'd30',
          component: () => import('@/components/device/d30')
        },
        {
          path: 'p35',
          name: 'p35',
          component: () => import('@/components/device/p35')
        },
      ]
    },
    // {
    //   path: '/qyzx',
    //   name: 'qyzx',
    //   component: () => import('@/components/qyzx/qyzx')
    // },
    {
      path: '/qyzx_children',
      name: 'qyzx_children',
      component: () => import('@/components/qyzx/children/qyzx_children'),
      children: [{
          path: '',
          name: 'qyzx',
          component: () => import('@/components/qyzx/qyzx')
        }, {
          path: 'hzhb',
          name: 'hzhb',
          component: () => import('@/components/qyzx/children/hzhb')
        },
        {
          path: 'hzfs',
          name: 'hzfs',
          component: () => import('@/components/qyzx/children/hzfs')
        },
        {
          path: 'zlrz',
          name: 'zlrz',
          component: () => import('@/components/qyzx/children/zlrz')
        },
        {
          path: 'lxwm',
          name: 'lxwm',
          component: () => import('@/components/qyzx/children/lxwm')
        },
        {
          path: 'fzlc',
          name: 'fzlc',
          component: () => import('@/components/qyzx/children/fzlc')
        },
        {
          path: 'first_stage',
          name: 'first_stage',
          component: () => import('@/components/qyzx/children/development_history/first_stage')
        },
        {
          path: 'second_stage',
          name: 'second_stage',
          component: () => import('@/components/qyzx/children/development_history/second_stage')
        },
        {
          path: 'third_stage',
          name: 'third_stage',
          component: () => import('@/components/qyzx/children/development_history/third_stage')
        },
      ]
    },
  ],

})



// WEBPACK FOOTER //
// ./src/router/index.js